import { BookType, SectionType } from 'types/types'

/** One entry in the book dropdown: "Section / Book / Hebrew name", in Tanakh order. */
export interface BookChoice {
  title: string
  value: BookType
}

const byOrder = (a: { order: number }, b: { order: number }) => a.order - b.order

/** Every book of every section, sorted by section order, then book order. */
export function bookChoices(sections: ReadonlyArray<SectionType>): Array<BookChoice> {
  return [...sections].sort(byOrder).flatMap((section) =>
    [...section.books].sort(byOrder).map((book) => ({
      title: `${section.transliteratedName} / ${book.transliteratedName} / ${book.heName}`,
      value: book,
    })),
  )
}
